import React from "react";
import { createRoot } from "react-dom/client";
import App from "./App.jsx";

class ReactRootElement extends HTMLElement {
  constructor() {
    super();
    this._root = null;
  }

  disconnectedCallback() {
    const root = this._root;

    if (!root) return;

    root.unmount();
    this._root = null;
  }

  connectedCallback() {
    // Always recreate root on connection to ensure fresh state
    if (this._root) {
      this._root.unmount();
      this._root = null;
    }
  }
}

class CareerJobApplicantFormElement extends ReactRootElement {
  connectedCallback() {
    if (!this._root) {
      const formType = this.getAttribute("form-type") || "careerApplication";
      this._root = createRoot(this);
      this._root.render(<App formType={formType} />);
    }
  }
}

class BecomeAdvisorFormElement extends ReactRootElement {
  connectedCallback() {
    if (!this._root) {
      const formType = this.getAttribute("form-type") || "becomeApplication";
      this._root = createRoot(this);
      this._root.render(<App formType={formType} />);
    }
  }
}

class BranchLocatorFormElement extends ReactRootElement {
  connectedCallback() {
    if (!this._root) {
      const formType = "branchLocator";

      this._root = createRoot(this);
      this._root.render(<App formType={formType} />);
    }
  }
}

class ContactpartnersElement extends ReactRootElement {
  connectedCallback() {
    if (!this._root) {
      const formType = "contactpartners";

      this._root = createRoot(this);
      this._root.render(<App formType={formType} />);
    }
  }
}

class UnclaimedAmountElement extends ReactRootElement {
  connectedCallback() {
    if (!this._root) {
      const formType = "unclaimedAmount";

      this._root = createRoot(this);
      this._root.render(<App formType={formType} />);
    }
  }
}

class UnclaimedSeniorCitizenElement extends ReactRootElement {
  connectedCallback() {
    if (!this._root) {
      const formType = "unclaimedSeniorCitizen";

      this._root = createRoot(this);
      this._root.render(<App formType={formType} />);
    }
  }
}

class TrackGrievanceRedressalElement extends ReactRootElement {
  connectedCallback() {
    if (!this._root) {
      const formType = "trackGrievanceStatus";

      this._root = createRoot(this);
      this._root.render(<App formType={formType} />);
    }
  }
}

class CreateGrievanceRedressalElement extends ReactRootElement {
  connectedCallback() {
    if (!this._root) {
      const formType = "createGrievanceRedressal";

      this._root = createRoot(this);
      this._root.render(<App formType={formType} />);
    }
  }
}

class NavFundDetailsElement extends ReactRootElement {
  connectedCallback() {
    if (!this._root) {
      const formType = "navFundDetails";

      this._root = createRoot(this);
      this._root.render(<App formType={formType} />);
    }
  }
}

class GroupPolicyFormElement extends ReactRootElement {
  connectedCallback() {
    if (!this._root) {
      const formType = "groupPolicyForm";
      this._root = createRoot(this);
      this._root.render(<App formType={formType} />);
    }
  }
}

class TrackClaimFormElement extends ReactRootElement {
  connectedCallback() {
    if (!this._root) {
      const formType = "trackClaimCustomer";
      this._root = createRoot(this);
      this._root.render(<App formType={formType} />);
    }
  }
}

class ClaimIntimationFormElement extends ReactRootElement {
  connectedCallback() {
    if (!this._root) {
      const formType = "claimIntimationCustomer";
      this._root = createRoot(this);
      this._root.render(<App formType={formType} />);
    }
  }
}

class AiHubFormElement extends ReactRootElement {
  connectedCallback() {
    if (!this._root) {
      const formType = "aiHubForm";
      this._root = createRoot(this);
      this._root.render(<App formType={formType} />);
    }
  }
}

class CustomerReviewFormElement extends ReactRootElement {
  connectedCallback() {
    if (!this._root) {
      const formType = "customerReviewForm";
      this._root = createRoot(this);
      this._root.render(<App formType={formType} />);
    }
  }
}

class OurFundsFormElement extends ReactRootElement {
  connectedCallback() {
    if (!this._root) {
      const formType = "ourFundsForm";
      this._root = createRoot(this);
      this._root.render(<App formType={formType} />);
    }
  }
}

class EcsPremiumOffsetConsentElement extends ReactRootElement {
  connectedCallback() {
    if (!this._root) {
      const formType = "ecsPremiumOffsetConsent";
      this._root = createRoot(this);
      this._root.render(<App formType={formType} />);
    }
  }
}

// Register all custom forms elements
const CAREER_JOB_APPLICATION_ELEMENT_NAME = "career-job-applicant-form";
const BECOME_ADVISOR_ELEMENT_NAME = "become-advisor-form";
const BRANCH_LOCATOR_ELEMENT_NAME = "branch-locator-form";
const CONTACT_PARTNERS_ELEMENT_NAME = "contact-partners";
const UNCALIMED_AMOUNT_ELEMENT_NAME = "unclaimed-amount";
const UNCLAIMED_SENIOR_CITIZEN_ELEMENT_NAME = "unclaimed-senior-citizen";
const TRACK_GRIEVANCE_REDRESSAL = "track-grievance-redressal";
const CREATE_GRIEVANCE_REDRESSAL = "create-grievance-redressal";
const NAV_FUND_DETAILS_ELEMENT_NAME = "nav-fund-details";
const TRACK_CLAIM_CUSTOMER = "track-claim-customer";
const CLAIM_INTIMATION_CUSTOMER = "claim-intimation-customer";
const GROUP_POLICY_ELEMENT = "group-policy-form";
const OUR_FUNDS_FORM = "our-funds-form";
const AI_HUB = "ai-hub-form";
const CUSTOMER_REVIEW = "customer-review-form";
const ECS_PREMIUM_OFFSET_CONSENT = "ecs-premium-offset-consent";

if (!customElements.get(CAREER_JOB_APPLICATION_ELEMENT_NAME)) {
  customElements.define(
    CAREER_JOB_APPLICATION_ELEMENT_NAME,
    CareerJobApplicantFormElement,
  );
}
if (!customElements.get(OUR_FUNDS_FORM)) {
  customElements.define(OUR_FUNDS_FORM, OurFundsFormElement);
}

if (!customElements.get(BECOME_ADVISOR_ELEMENT_NAME)) {
  customElements.define(BECOME_ADVISOR_ELEMENT_NAME, BecomeAdvisorFormElement);
}

if (!customElements.get(BRANCH_LOCATOR_ELEMENT_NAME)) {
  customElements.define(BRANCH_LOCATOR_ELEMENT_NAME, BranchLocatorFormElement);
}

if (!customElements.get(CONTACT_PARTNERS_ELEMENT_NAME)) {
  customElements.define(CONTACT_PARTNERS_ELEMENT_NAME, ContactpartnersElement);
}

if (!customElements.get(UNCALIMED_AMOUNT_ELEMENT_NAME)) {
  customElements.define(UNCALIMED_AMOUNT_ELEMENT_NAME, UnclaimedAmountElement);
}

if (!customElements.get(UNCLAIMED_SENIOR_CITIZEN_ELEMENT_NAME)) {
  customElements.define(UNCLAIMED_SENIOR_CITIZEN_ELEMENT_NAME, UnclaimedSeniorCitizenElement);
}

if (!customElements.get(TRACK_GRIEVANCE_REDRESSAL)) {
  customElements.define(
    TRACK_GRIEVANCE_REDRESSAL,
    TrackGrievanceRedressalElement,
  );
}

if (!customElements.get(CREATE_GRIEVANCE_REDRESSAL)) {
  customElements.define(
    CREATE_GRIEVANCE_REDRESSAL,
    CreateGrievanceRedressalElement,
  );
}

if (!customElements.get(NAV_FUND_DETAILS_ELEMENT_NAME)) {
  customElements.define(NAV_FUND_DETAILS_ELEMENT_NAME, NavFundDetailsElement);
}

if (!customElements.get(GROUP_POLICY_ELEMENT)) {
  customElements.define(GROUP_POLICY_ELEMENT, GroupPolicyFormElement);
}

if (!customElements.get(AI_HUB)) {
  customElements.define(AI_HUB, AiHubFormElement );
}

if (!customElements.get(CUSTOMER_REVIEW)) {
  customElements.define(CUSTOMER_REVIEW, CustomerReviewFormElement );
}

if (!customElements.get(TRACK_CLAIM_CUSTOMER)) {
  customElements.define(TRACK_CLAIM_CUSTOMER, TrackClaimFormElement);
}

if (!customElements.get(CLAIM_INTIMATION_CUSTOMER)) {
  customElements.define(CLAIM_INTIMATION_CUSTOMER, ClaimIntimationFormElement);
}

if (!customElements.get(ECS_PREMIUM_OFFSET_CONSENT)) {
  customElements.define(ECS_PREMIUM_OFFSET_CONSENT, EcsPremiumOffsetConsentElement);
}

class BlogDetailsElement extends ReactRootElement {
  connectedCallback() {
    if (!this._root) {
      const formType = "blogDetails";
      this._root = createRoot(this);
      this._root.render(<App formType={formType} />);
    }
  }
}

const BLOG_DETAILS_ELEMENT_NAME = "blog-details";

if (!customElements.get(BLOG_DETAILS_ELEMENT_NAME)) {
  customElements.define(BLOG_DETAILS_ELEMENT_NAME, BlogDetailsElement);
}
